import {addToast, copyToClipboard} from '@albert-io/atomic';

import constants from 'client/constants';

/**
 * The URL an assigned student takes the diagnostic at — one stable link per diagnostic, identical
 * for every student (`diagnostics/$diagnosticId` in the route tree).
 *
 * Built rather than read off the address bar: a teacher sharing this is standing on the assign
 * page or the dashboard, neither of which a student can open.
 */
export const studentDiagnosticLink = (diagnosticId: string): string =>
  `${constants.ALBERT_FULL_PATH}/diagnostics/${diagnosticId}`;

export const copyStudentDiagnosticLink = (diagnosticId: string): void => {
  copyToClipboard(studentDiagnosticLink(diagnosticId), () => {
    addToast({color: 'positive', message: 'Copied to clipboard'});
  });
};
